<template>
    <div class="container">

        <div class="bottom">
            <div class="block1 flex-col" @click="showPopup(1, '你的专属“救业计划”名片')">
              <div class="main1 flex-col">
                <span class="txt1">“救业”咨询师登记</span>
                <span class="txt2">助人心善的小可爱快进来吧～</span>
                <div class="section1 flex-col">
                  <div class="main2 flex-row">
                    <span class="txt3">去登记 &gt;</span>
                  </div>
                </div>
              </div>
              <img
                class="img1"
                referrerpolicy="no-referrer"
                src="../../../assets/ms_activity/img1.png"
              />
            </div>
            <div class="block2 flex-col" @click="showPopup(2, '“救业”咨询师奖章海报')">
              <div class="outer1 flex-row">
                <div class="section2 flex-col">
                  <span class="txt4">“救业”咨询师奖章</span>
                  <span class="txt5">感谢你带给我们希望与温暖～</span>
                </div>
              </div>
              <div class="group1 flex-col" v-if="!isOpenPopup2">
                <div class="block3 flex-row">
                  <img
                    class="label2"
                    referrerpolicy="no-referrer"
                    src="../../../assets/ms_activity/icon.png"
                  />
                  <span class="word3">咨询结束后开放此功能</span>
                </div>
              </div>
              <div class="outer2 flex-row" v-else>
                <div class="outer3 flex-col">
                  <div class="section5 flex-row">
                    <span class="info1">去生成 &gt;</span>
                  </div>
                </div>
              </div>
              <img
                class="img2"
                referrerpolicy="no-referrer"
                src="../../../assets/ms_activity/img2.png"
              />
            </div>
        </div>

        <van-popup v-model="showPopup1" position="bottom">
            <div class="popup1">
                <div class="mod4 flex-col">
                    <div class="box11 flex-col">
                      <div class="section3 flex-row">
                        <span class="word3">你的名字</span>
                        <span class="info4">(每一次付出都值得纪念)</span>
                      </div>
                      <div class="section4 flex-col">
                        <span class="word4">
                            <input type="text" class="txt" placeholder="请输入真实姓名" v-model="popup1.name">
                        </span>
                      </div>
                      <div class="section5 flex-row">
                        <span class="txt3">添加你的美照</span>
                        <span class="word5">(最好有露脸哦～)</span>
                      </div>
                      <div class="section6 flex-col" v-if="!popup1.photo">
                        <div class="block1 flex-col" @click="uploadImgHandle">
                          <div class="mod5 flex-col">
                            <img
                              class="label1"
                              referrerpolicy="no-referrer"
                              src="../../../assets/ms_activity/photo.png"
                            />
                          </div>
                          <span class="word6">添加图片</span>
                        </div>
                      </div>
                      <template v-else>
                          <img
                            class="pic11"
                            referrerpolicy="no-referrer"
                            :src="popup1.photo"
                          />
                          <div class="outer4 flex-col" @click="popup1.photo = ''"></div>
                      </template>
                      
                      <div class="section7 flex-col" @click="createPoster('你的专属“救业计划”名片')">
                        <span class="txt4">生成你的专属“救业计划”名片</span>
                      </div>
                    </div>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="showPopup2" position="bottom">
            <div class="popup2">
                <div class="outer5 flex-col">
                    <div class="outer6 flex-col">
                      <div class="main3 flex-row">
                        <span class="word7">你的名字</span>
                        <span class="txt1">(每一次付出都值得纪念)</span>
                      </div>
                      <div class="main4 flex-col">
                          <span class="word8">
                            <input type="text" class="txt" placeholder="请输入真实姓名" v-model="popup2.name">
                          </span>
                      </div>
                      <span class="info2">咨询数量</span>
                      <div class="main5 flex-col">
                        <span class="word9">
                            <input type="number" class="txt" placeholder="请输入数字" v-model="popup2.count">
                        </span>
                      </div>
                      <div class="main6 flex-col" @click="createPoster('“救业”咨询师奖章海报')">
                        <span class="word10">生成“救业”咨询师奖章海报</span>
                      </div>
                    </div>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="showPoster">
            <div class="poster">
              <img :src="poster">
            </div>
            <p class="tips">长按转发海报</p>
            <a href="javascript:;" class="edit" @click="back">重新生成{{title}}</a>
        </van-popup>

        <div v-show="showPoster" class="close" @click="showPoster = false"><img src="../../../assets/ms_activity/exit.png"></div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { getStorage, setStorage, deleteStorage, isLocal, isMain, cache } from "@/utils/tools";
import { poster_activity816, shengya_activity_upload_img, } from '@/api/other';
// import { shareCon } from "@/utils/wxconfig";
import wx from "weixin-js-sdk"

export default {
    data(){
        return {
            showPoster: false,
            showPopup1: false,
            showPopup2: false,
            popup1: {
                name: '',
                photo: '',
            },
            popup2: {
                name: '',
                count: '',
            },
            poster: '',
            title: '',
            idx: 0,
            serverId: '',
            isOpenPopup2: true,
        }
    },
    methods:{
        pullData(){
            this.loading = Toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true,
            });
        },
        back() {
            let cache_key = this.getCacheKey(this.idx);
            cache(cache_key, '');

            this.showPoster = false;
            if(this.idx == 1) {
                this.showPopup1 = true;
            } else if (this.idx == 2) {
                this.showPopup2 = true;
            }
        },
        getCacheKey(idx) {
          let site = isMain() ? 'main' : 'test';
          let cache_key = `${site}:activity816:poster${idx}`;
          return cache_key;
        },
        showPopup(idx, title) {
            if(idx == 2 && !this.isOpenPopup2) {
              return;
            }

            this.idx = idx;
            this.title = title;

            let cache_key = this.getCacheKey(idx);
            let poster = cache(cache_key);

            if(poster) {
              this.poster = poster;
              this.showPoster = true;
            } else {
              if(idx == 1) {
                this.showPopup1 = true;
              } else if (idx == 2) {
                this.showPopup2 = true;
              }
            }
        },
        createPoster(title) {
            this.title = title;
            let data = {};

            if(this.showPopup1) {
                this.idx = 1;
                data.name = this.popup1.name;
                data.photo = this.popup1.photo;

                if(!data.name) {
                    this.$toast('请输入姓名');
                    return;
                }

                if(!data.photo) {
                    this.$toast('请上传图片');
                    return;
                }
            } else if (this.showPopup2) {
                this.idx = 2;
                data.name = this.popup2.name;
                data.count = this.popup2.count;

                if(!data.name) {
                    this.$toast('请输入姓名');
                    return;
                }

                if(data.count==='') {
                    this.$toast('请输入咨询数量');
                    return;
                }
            }

            poster_activity816(data).then(res=>{
                if(res.error > 0) {
                    this.$toast(res.msg || '请求失败');
                    return;
                }

                this.poster = res.image_url;
                let cache_key = this.getCacheKey(this.idx);
                cache(cache_key, this.poster);

                this.showPopup1 = false;
                this.showPopup2 = false;
                this.showPoster = true;
            });
        },
        // 上传图片
        uploadImgHandle() {
            wx.chooseImage({
              count: 1,
              sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
              sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
              success: (res) => {
                // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                wx.uploadImage({
                  localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
                  isShowProgressTips: 1, // 默认为1，显示进度提示
                  success: (res) => {
                    this.serverId = res.serverId;
                    this.imgSave();
                  }
                });
              }
            });
        },
        imgSave() {
            shengya_activity_upload_img({
                server_id: this.serverId
              })
              .then(data => {
                this.popup1.photo = data.imgurl;
              });
        },
    },
    mounted() {
        document.title = '2021救业计划';
        // window.vm = this;
        // this.pullData();
    }
}
</script>
<style lang="scss" scoped>
    .container {
        width: 100%;
        height: 100%;
        background: url(../../../assets/ms_activity/bg.png) no-repeat top center;
        background-size: 100%;
        background-color: #FF8D00;
        position: relative;
    }

    // .container ::v-deep .van-overlay {
    //     background-color: rgba(0,0,0,0.8) !important;
    // }
    .container ::v-deep .van-popup {
        background-color: transparent;
        overflow-x: visible;
    }

    .flex-col {
      display: flex;
      flex-direction: column;
    }
    .flex-row {
      display: flex;
      flex-direction: row;
    }
    .txt {
        background: none;
        border: none;
        outline: none;
        color: #2B333A;
        display: block;
        box-sizing: border-box;
        width: 100%;

        &::placeholder {
          color: #A9AFB3;
        }
    }

    .popup2 {
        width: 750px;
        height: 703px;
        background: #FFFFFF;
        border-radius: 40px 40px 0px 0px;

        .outer5 {
          z-index: 191;
          height: 703px;
          border-radius: 40px 40px 0 0;
          background-color: rgba(255, 255, 255, 1);
          width: 750px;
          justify-content: flex-start;
          padding-top: 50px;
          align-items: center;
        }
        .outer6 {
          z-index: auto;
          width: 670px;
          height: 593px;
        }
        .main3 {
          z-index: auto;
          width: 472px;
          height: 59px;
          justify-content: space-between;
        }
        .word7 {
          z-index: 192;
          width: 168px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(43, 51, 58, 1);
          font-size: 42px;
          font-family: PingFangSC-Semibold;
          white-space: nowrap;
          line-height: 59px;
          text-align: left;
        }
        .txt1 {
          z-index: 193;
          width: 299px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(125, 130, 137, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
          margin-top: 15px;
        }
        .main4 {
          z-index: 195;
          height: 88px;
          border-radius: 20px;
          background-color: rgba(242, 243, 245, 1);
          margin-top: 16px;
          width: 670px;
          justify-content: center;
          align-items: flex-start;
          padding-left: 24px;
        }
        .word8 {
          z-index: 196;
          width: 100%;
          display: block;
          overflow-wrap: break-word;
          color: rgba(169, 175, 179, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
        }
        .info2 {
          z-index: 200;
          width: 168px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(43, 51, 58, 1);
          font-size: 42px;
          font-family: PingFangSC-Semibold;
          white-space: nowrap;
          line-height: 59px;
          text-align: left;
          align-self: flex-start;
          margin-top: 40px;
        }
        .main5 {
          z-index: 198;
          height: 88px;
          border-radius: 20px;
          background-color: rgba(242, 243, 245, 1);
          margin-top: 16px;
          width: 670px;
          justify-content: center;
          align-items: flex-start;
          padding-left: 24px;
        }
        .word9 {
          z-index: 199;
          width: 100%;
          display: block;
          overflow-wrap: break-word;
          color: rgba(169, 175, 179, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
        }
        .main6 {
          z-index: 202;
          height: 88px;
          border-radius: 44px;
          box-shadow: 0px 6px 18px 0px rgba(255, 141, 0, 0.3);
          background: linear-gradient(180deg, #FF9726 0%, #FF7200 100%);
          align-self: center;
          margin-top: 139px;
          width: 630px;
          justify-content: center;
          align-items: center;
        }
        .word10 {
          z-index: 203;
          width: 439px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(255, 255, 255, 1);
          font-size: 36px;
          font-family: PingFangSC-Medium;
          white-space: nowrap;
          line-height: 50px;
          text-align: center;
        }
    }

    .popup1 {
        width: 750px;
        height: 716px;
        background: #FFFFFF;
        border-radius: 40px 40px 0px 0px;

        .pic11 {
          z-index: 196;
          width: 160px;
          height: 160px;
          align-self: flex-start;
          margin-top: 16px;
        }
        .outer4 {
          z-index: 201;
          position: absolute;
          left: 183px;
          top: 311px;
          width: 35px;
          height: 35px;
          background: url(../../../assets/ms_activity/del.png) -1px -1px
            no-repeat;
          background-size: 100% 100%;
        }

        .mod4 {
          z-index: 191;
          height: 716px;
          border-radius: 40px 40px 0 0;
          background-color: rgba(255, 255, 255, 1);
          width: 750px;
          justify-content: flex-start;
          padding-top: 50px;
          align-items: center;
        }
        .box11 {
          z-index: auto;
          width: 670px;
          height: 606px;
        }
        .section3 {
          z-index: auto;
          width: 472px;
          height: 59px;
          justify-content: space-between;
        }
        .word3 {
          z-index: 195;
          width: 168px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(43, 51, 58, 1);
          font-size: 42px;
          font-family: PingFangSC-Semibold;
          white-space: nowrap;
          line-height: 59px;
          text-align: left;
        }
        .info4 {
          z-index: 196;
          width: 299px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(125, 130, 137, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
          margin-top: 15px;
        }
        .section4 {
          z-index: 193;
          height: 88px;
          border-radius: 20px;
          background-color: rgba(242, 243, 245, 1);
          margin-top: 16px;
          width: 670px;
          justify-content: center;
          align-items: flex-start;
          padding-left: 24px;
        }
        .word4 {
          z-index: 194;
          width: 100%;
          display: block;
          overflow-wrap: break-word;
          color: rgba(169, 175, 179, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
        }
        .section5 {
          z-index: auto;
          width: 472px;
          height: 59px;
          margin-top: 40px;
          justify-content: space-between;
        }
        .txt3 {
          z-index: 197;
          width: 252px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(43, 51, 58, 1);
          font-size: 42px;
          font-family: PingFangSC-Semibold;
          white-space: nowrap;
          line-height: 59px;
          text-align: left;
        }
        .word5 {
          z-index: 198;
          width: 215px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(125, 130, 137, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
          margin-top: 15px;
        }
        .section6 {
          z-index: 200;
          height: 160px;
          border-radius: 10px;
          border-width: 2px;
          border: 2px dashed rgba(216, 216, 216, 1);
          align-self: flex-start;
          margin-top: 16px;
          width: 160px;
          justify-content: center;
          align-items: center;
        }
        .block1 {
          z-index: auto;
          width: 96px;
          height: 86px;
        }
        .mod5 {
          z-index: 203;
          height: 48px;
          background-color: rgba(255, 255, 255, 0);
          align-self: center;
          width: 48px;
          justify-content: center;
          align-items: center;
        }
        .label1 {
          z-index: 204;
          width: 40px;
          height: 36px;
        }
        .word6 {
          z-index: 210;
          width: 96px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(169, 175, 179, 1);
          font-size: 24px;
          white-space: nowrap;
          line-height: 33px;
          text-align: left;
          margin-top: 5px;
        }
        .section7 {
          z-index: 212;
          height: 88px;
          border-radius: 44px;
          box-shadow: 0px 6px 18px 0px rgba(255, 141, 0, 0.3);
          background: linear-gradient(180deg, #FF9726 0%, #FF7200 100%);
          align-self: center;
          margin-top: 80px;
          width: 630px;
          justify-content: center;
          align-items: center;
        }
        .txt4 {
          z-index: 213;
          width: 475px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(255, 255, 255, 1);
          font-size: 36px;
          font-family: PingFangSC-Medium;
          white-space: nowrap;
          line-height: 50px;
          text-align: center;
        }
    }

    .bottom {
        position: absolute;
        bottom: 30px;
        left: 40px;
        right: 40px;

        .group1 {
          z-index: 202;
          height: 42px;
          border-radius: 10px;
          background-color: rgba(255, 192, 87, 0.2);
          width: 306px;
          justify-content: center;
          align-items: center;
          margin-left: 32px;
        }
        .block3 {
          z-index: auto;
          width: 274px;
          height: 33px;
          justify-content: space-between;
        }
        .label2 {
          z-index: 203;
          width: 26px;
          height: 26px;
          margin-top: 3px;
        }
        .word3 {
          z-index: 208;
          width: 240px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(255, 173, 37, 1);
          font-size: 24px;
          font-family: PingFangSC-Regular;
          white-space: nowrap;
          line-height: 33px;
          text-align: left;
        }

        .block1 {
          z-index: 66;
          height: 200px;
          border-radius: 20px;
          overflow: hidden;
          background: #FFFFFF;
          align-self: center;
          width: 670px;
          justify-content: center;
          align-items: flex-start;
          padding-left: 32px;
          position: relative;
        }
        .main1 {
          z-index: auto;
          width: 364px;
          height: 142px;
        }
        .txt1 {
          z-index: 149;
          width: 297px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(43, 51, 58, 1);
          font-size: 36px;
          font-family: PingFangSC-Semibold;
          white-space: nowrap;
          line-height: 50px;
          text-align: left;
          align-self: flex-start;
        }
        .txt2 {
          z-index: 150;
          width: 364px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(125, 130, 137, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
        }
        .section1 {
          z-index: 152;
          height: 42px;
          border-radius: 21px;
          background-color: rgba(255, 0, 0, 1);
          align-self: flex-start;
          margin-top: 10px;
          width: 120px;
          justify-content: center;
          align-items: center;
        }
        .main2 {
          z-index: auto;
          width: 88px;
          height: 33px;
          justify-content: space-between;
        }
        .txt3 {
          z-index: 159;
          width: 72px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(255, 255, 255, 1);
          font-size: 24px;
          white-space: nowrap;
          line-height: 33px;
          text-align: left;
        }
        .img1 {
          z-index: 68;
          position: absolute;
          right: 24px;
          bottom: 0px;
          width: 148px;
          height: 187px;
        }
        .img2 {
          z-index: 68;
          position: absolute;
          right: 24px;
          bottom: 31px;
          width: 180px;
          height: 138px;
        }

        .block2 {
          z-index: 182;
          height: 200px;
          border-radius: 20px;
          background: #FFFFFF;
          align-self: center;
          margin-top: 20px;
          width: 670px;
          position: relative;
        }
        .outer1 {
          z-index: auto;
          width: 615px;
          height: 98px;
          margin: 29px 0 0 32px;
        }
        .section2 {
          z-index: auto;
          width: 364px;
          height: 90px;
        }
        .txt4 {
          z-index: 199;
          width: 297px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(43, 51, 58, 1);
          font-size: 36px;
          font-family: PingFangSC-Semibold;
          white-space: nowrap;
          line-height: 50px;
          text-align: left;
          align-self: flex-start;
        }
        .txt5 {
          z-index: 200;
          width: 364px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(125, 130, 137, 1);
          font-size: 28px;
          white-space: nowrap;
          line-height: 40px;
          text-align: left;
        }
        .outer2 {
          z-index: auto;
          width: 603px;
          height: 42px;
          margin: 2px 0 0 32px;
        }
        .outer3 {
          z-index: 202;
          height: 42px;
          border-radius: 21px;
          background-color: rgba(255, 0, 0, 1);
          width: 120px;
          justify-content: center;
          align-items: center;
        }
        .section5 {
          z-index: auto;
          width: 88px;
          height: 33px;
          justify-content: space-between;
        }
        .info1 {
          z-index: 209;
          width: 72px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(255, 255, 255, 1);
          font-size: 24px;
          white-space: nowrap;
          line-height: 33px;
          text-align: left;
        }
    }

    .close {
        z-index: 2021;
        position: absolute;
        width: 40px;
        height: 40px;
        top: 20px;
        right: 45px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .poster {
        width: 540px;
        height: auto;
        margin: 0 auto;
        margin-top: 40px;

        img {
            width: 100%;
            height: 100%;
        }
    }
    .tips {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 28px;
        text-align: center;
        font-weight: 400;
        color: #fff;
        line-height: 40px;
        margin: 16px 0;
    }
    .edit {
        display: block;
        margin: 24px auto;
        box-sizing: border-box;
        line-height: 80px;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        width: 520px;
        height: 80px;
        background: linear-gradient(180deg, #FF9726 0%, #FF7200 100%);
        box-shadow: 0px 6px 18px 0px rgba(255, 141, 0, 0.3);
        border-radius: 49px;
    }
</style>